import React from 'react'
import { oneOf, func } from 'prop-types'
import isPropTypeHexCode from 'utils/isPropTypeHexCode'
import { Button as StyledButton } from './styles'

const Button = ({ children, type, onClick, disabled, loading, ...rest }) => (
	<StyledButton type={type} onClick={onClick} disabled={disabled} {...rest}>
		{children}
	</StyledButton>
)

Button.propTypes = {
	type: oneOf(['submit', 'button']),
	onClick: func.isRequired,
	backgroundColor: isPropTypeHexCode,
	foreground: isPropTypeHexCode
}

Button.defaultProps = {
	onClick: () => {}
}

export default Button
